import { setMobileView, setTabletView } from "../tools/mobileView";

// Height
export const headerHeight = '8vh';
export const bodyHeight = '84vh';
export const footerHeight = '8vh';

// Slideshow
export const slideshowDimensions = setMobileView() ? '200px' : setTabletView() ? '300px' : '600px';
export const componentSlideshowHeight = setMobileView() ? '260px' : setTabletView() ? '280px' : '350px';
export const componentSlideshowWidth = setMobileView() ? '200px' : setTabletView() ? '200px' : '230px';
export const slideshowSpanText = setMobileView() ? '15px' : '25px';

export const defaultTheme = {
  palette: {
    primary: {
      main: "#ffffff",
      light: "#f5f5f5",
      dark: "#e0e0e0",
      contrastText: "#1a1a1a",
      background: "#ffffff",
      backgroundOpacityLight: "255,255,255,0.6",
      backgroundOpacityDark: "0,0,0,0.05",
      text: "#1a1a1a",
      textSecondary: "#4d4d4d",
      accent: "#bfbfbf",
      svg: "filter: invert(10%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(96%) contrast(92%)"
    },
    secondary: {
      main: "#1a1a1a",
      light: "#2f2f2f",
      dark: "#000000",
      contrastText: "#ffffff",
      background: "#0f0f0f",
      backgroundOpacityDark: "26,26,26,0.85",
      backgroundOpacityLight: "34,34,34,0.3",
      text: "#ffffff",
      textSecondary: "#bfbfbf",
      accent: "#666666",
      svg: "filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)"
    },
    neutral: {
      main: "#999999",
      light: "#d9d9d9",
      dark: "#666666",
      contrastText: "#000000"
    },
    success: { main: "#28a745", contrastText: "#ffffff" },
    warning: { main: "#ffc107", contrastText: "#000000" },
    error: { main: "#dc3545", contrastText: "#ffffff" },
    info: { main: "#17a2b8", contrastText: "#ffffff" },
    border: "#ccc",
    link: "#007bff",
    text: {
      primary: "#212121",
      secondary: "#757575",
      disabled: "#bdbdbd"
    },
    background: {
      default: "#ffffff",
      paper: "#f4f4f4"
    }
  },
  typography: {
    fontFamily: "'Segoe UI', sans-serif",
    baseSize: "16px",
    sizes: {
      h1: "2rem",
      h2: "1.75rem",
      h3: "1.5rem",
      h4: "1.25rem",
      body: "1rem",
      small: "0.875rem"
    },
    weights: {
      light: 300,
      normal: 400,
      bold: 700
    }
  },
  layout: {
    spacing: {
      xs: "4px",
      sm: "8px",
      md: "16px",
      lg: "32px"
    },
    borderRadius: "6px",
    shadow: {
      sm: "0 1px 2px rgba(0,0,0,0.05)",
      md: "0 4px 6px rgba(0,0,0,0.08)",
      lg: "0 10px 20px rgba(0,0,0,0.1)"
    },
    card: {
      background: "#ffffff",
      borderRadius: "12px"
    }
  },
  behavior: {
    transition: "0.3s ease-in-out",
    backdrop: {
      enabled: true,
      blurAmount: "4px"
    },
    backgroundImageOn: false
  },
  Images: [],
  options: {
    backgroundImageOn: false
  }
};